import React from "react"
import {
    Container,
    Col,
    Row} from 'reactstrap';
    import facebook from './images/facebook.png'
    import twitter from './images/twitter.png'
    import whatsapp from './images/whatsapp.png'
    import logoblue from './images/logoblue.png'
    import Header from "./Header"


function Intro(){
    return(
    <div>
    <Header/>
        <Container>
            <Row>
                    <Col xs="12" className="text-left">
                    <br/>
                    <br/>
                        <p>Armed with US-made bombs and British-made fighter jets, Saudi Arabia and its allies have been waging a ruinous war on Yemen for the last four years.</p>
                        <p>Since they intervened in the country's civil war on March 26, 2015, more than 19,000 raids have been carried out in Yemen, the Arab world's poorest country.</p>
                        <p>When the aerial campaign commenced, expectations were high that the coalition assembled by Saudi Crown Prince Mohammed bin Salman would crush the Houthi rebellion within a matter of weeks.</p>
                        <p>But after nearly four years of fighting, and an estimated 60,000 deaths, the coalition has failed to pave the way for the recapture of the capital, Sanaa, and most urban centres.</p>
                        <p>Despite assurances by the coalition that all precautionary measures would be taken to avoid civilian casualties, a sizable number of coalition attacks have targeted civilian areas.</p>
                        <p>According to data collected by the Yemen Data Project, nearly two-thirds of the coalition’s air raids have struck non-military and unknown targets.</p>
                        <p>Airports, ports, bridges and roads have all been repeatedly attacked.</p>
                        <p>So too have farms, schools, oil and gas facilities, factories and private businesses.</p>
                        <p>According to rights groups, the coalition has not accidentally attacked civilian infrastructure – it has been doing it deliberately.</p>
                        <p>Between June and September, when the coalition launched a new offensive on the port city of Hodeidah, fatalities increased by a staggering 164 percent.</p>
                        <p>Because of these incessant attacks, Yemen's civilian, economic and medical infrastructures have been pushed to the brink of collapse. Today, Yemen is the site of a horrific civil war, and the world's worst humanitarian crises.</p>
                        <p>According to the United Nations, up to 20 million Yemenis, roughly two-thirds of the country's population, are food insecure.</p>
                        <p>Thousands of people are starving to death, while an average of eight civilians die from bombs and bullets every day.</p>
                        <p>In this interactive, based on data collected by the Yemen Data Project, an air raid refers to a single incident which could comprise multiple attacks.</p>
                        <p>Because it was not possible to generate an average number as these vary greatly, from one attack up to several dozen, so-called "double taps" have been counted as one air raid, not two.</p>
                    <br/>
                    <br/>
                </Col>
            </Row>
        </Container>
    </div>
    )
}

export default Intro